import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './BreakCard.css';
import KebabDots from '../../../../assets/icons/KebabDots';
import CoffeeCup from '../../../../assets/icons/CoffeeCup';
import {TTimetableItem} from '../../../../redux/timetable/timetable.type';

interface BreakCardProps {
    breakItem?: Partial<Pick<TTimetableItem, 'title'>> & {subtitle?: string; duration?: string};
    onMenuClick?: () => void;
}

function BreakCard({
    breakItem = {},
    onMenuClick = () => {},
}: BreakCardProps) {
    const {t} = useTranslation('timetable');
    const {title = t('breakDefault'), subtitle = '', duration = ''} = breakItem;

    return (
        <css.container>
            <css.stickerCol>
                <CoffeeCup />
            </css.stickerCol>
            <css.content>
                <css.details>
                    <css.title>{title}</css.title>
                    {subtitle && <css.subtitle>{subtitle}</css.subtitle>}
                    {duration && <css.duration>{duration}</css.duration>}
                </css.details>
                <css.kebab onClick={onMenuClick}><KebabDots /></css.kebab>
            </css.content>
            <css.dragHandle />
        </css.container>
    );
}

export default BreakCard;
